import { FC, useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { PageUrlMeta } from 'src/utils/getPageUrlMeta';
import { Icon } from 'src/components';
import { useOutsideAlerter } from 'src/hooks';
import { msgs } from '../messages';
import * as S from './styles';

type HeaderSourceLanguageDropdownProps = {
  alternateLinks: PageUrlMeta['alternateLinks'];
};

export const HeaderSourceLanguageDropdown: FC<HeaderSourceLanguageDropdownProps> = ({
  alternateLinks,
}) => {
  const intl = useIntl();

  const dropdownRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);

  const toggle = useCallback(() => setIsOpen(o => !o), []);

  useOutsideAlerter(dropdownRef, close);

  return (
    <S.Dropdown data-testid="headerSourceLanguageDropdown" ref={dropdownRef}>
      <S.DropdownLabel data-testid="headerSourceLanguageDropdownLabel" onClick={toggle}>
        {intl.formatMessage(msgs.selectPageLanguage)}
        <S.ArrowIconContainer $rotate={isOpen}>
          <Icon name="chevronDown" />
        </S.ArrowIconContainer>
      </S.DropdownLabel>

      {isOpen && (
        <S.SourceLanguageDropdownOptions alternateLinks={alternateLinks} onSelect={close} />
      )}
    </S.Dropdown>
  );
};
